






import { computed, defineComponent, watch } from '@vue/composition-api';
import { useStore } from '@/store';
import { ActionTypes } from '@/store/actions';
import { MutationTypes } from '@/store/mutations';
import LoadingIcon from '@/components/UI/LoadingIcon.vue';

export default defineComponent({
    name: 'ScrollLoader',
    components: { LoadingIcon },
    setup () {
        const store = useStore();
        const isEnabled = computed(() => !store.getters.allListItemsLoaded && !store.state.isListLoading);
        const isLoading = computed(() => store.state.isNewListPageLoading);
        const loadMoreItemsTriggered = computed(
            () => store.state.checkIfNeedToLoadMoreItems && !store.state.isListLoading
        );

        const loadMoreIfBottomReached = () => {
            const atBottom = (window.innerHeight + window.pageYOffset) >= document.body.offsetHeight;
            if (atBottom && !isLoading.value) {
                store.dispatch(ActionTypes.ShowMoreListItems);
            }
        };

        watch(isEnabled, value => {
            if (value) {
                window.addEventListener('scroll', loadMoreIfBottomReached);
            } else {
                window.removeEventListener('scroll', loadMoreIfBottomReached);
            }
        });

        watch(loadMoreItemsTriggered, value => {
            if (value) {
                loadMoreIfBottomReached();
                store.commit(MutationTypes.SetCheckIfNeedToLoadMoreItems, false);
            }
        });

        return { isLoading };
    }
});
